import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DESTINOS, formatARS } from "../../lib/site";
import { useLivePrices, priceOf } from "../../lib/livePrices";
import { FadeUp, MaskLines, Eyebrow } from "../site/Motion";

const FromPrice = ({ city }) => {
  const p = priceOf(useLivePrices(), "Retiro", city, 0);
  return p ? <p data-testid="destino-from-price" className="mt-2 text-sm text-white/85">Desde {formatARS(p)} · Semicama</p> : null;
};

const Tile = ({ d, i, className }) => (
  <FadeUp delay={i * 0.08} className={className}>
    <Link to={d.to || `/pasajes?o=Retiro&d=${encodeURIComponent(d.city === "Buenos Aires" ? "Santiago del Estero" : d.city)}`} data-testid={`destino-tile-${i}`} className="group relative block h-full min-h-[260px] overflow-hidden rounded-[28px] bg-[var(--ink)]">
      <motion.img src={d.img} alt={d.city} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 md:p-8">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--lime)]">{d.tag}</p>
          <p className={`mt-2 font-display text-white ${i === 0 ? "text-4xl md:text-6xl" : "text-3xl"}`}>{d.city}</p>
          {d.from && <FromPrice city={d.city} />}
        </div>
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-white/40 text-white transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-[var(--lime)] group-hover:text-[var(--ink)]">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </Link>
  </FadeUp>
);

export const DestinosBento = () => (
  <section data-testid="home-destinos" className="bg-[var(--paper)] py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="mb-12 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <Eyebrow>Destinos</Eyebrow>
          <h2 className="mt-5 font-display text-4xl md:text-6xl"><MaskLines inView lines={["¿A dónde", "te llevamos?"]} /></h2>
        </div>
        <Link to="/destinos" data-testid="destinos-see-all" className="group inline-flex items-center gap-2 self-start font-bold text-[var(--forest)] md:self-auto">
          Ver recorridos y paradas <ArrowUpRight className="h-5 w-5 transition-transform group-hover:rotate-45" />
        </Link>
      </div>
      <div className="grid auto-rows-[260px] grid-cols-1 gap-4 md:grid-cols-4 md:auto-rows-[280px]">
        <Tile d={DESTINOS[0]} i={0} className="md:col-span-2 md:row-span-2" />
        <Tile d={DESTINOS[1]} i={1} className="md:col-span-2" />
        <Tile d={DESTINOS[2]} i={2} />
        <Tile d={DESTINOS[3]} i={3} />
        <Tile d={DESTINOS[4]} i={4} className="md:col-span-4 md:h-[280px]" />
      </div>
    </div>
  </section>
);
